module.exports = __webpack_public_path__ + "img/03.355a9f1f.svg";